import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { referralRoute } from '.'

const ReferralPolicy = lazyRouteComponent(
  () => import('../../../pages/profile/referral/referral-policy'),
)

export const referralPolicyRoute = createRoute({
  getParentRoute: () => referralRoute,
  path: 'referral-policy',
  component: ReferralPolicy,
})
